<clr-dropdown
  class="dropdown"
  [ngClass]="{ open: isPopupOpen, disabled: disabled }"
  >
  <div [id]="id + '-dropdown'" class="action" (click)="switchPopup()">
    @if (!currentSelectedItem && !placeholder) {
      <div
        class="value placeholder"
        i18n="@@SelectPlaceholder"
        >
      {{ 'CommonWebUI_Select_Placeholder' | translate }}
    </div>
    }
    @if (!currentSelectedItem && placeholder) {
      <div class="value placeholder">
        {{ placeholder }}
      </div>
    }
    @if (currentSelectedItem) {
      <div
        class="value"
        [innerHTML]="currentSelectedContentItem"
      ></div>
    }
    <div class="icon" [ngClass]="{ disabled: disabled }"></div>
  </div>
  @if (isPopupOpen) {
    <clr-dropdown-menu
      class="popup"
      clrPosition="bottom-left"
      [style.height.rem]="currentHeight"
      >
      @if (hasSearch) {
        <div class="search" #searchInput>
          <daui-search-input
            [id]="id + '-dropdown'"
            [debounceTime]="100"
            [text]="textSearch"
            [isMultiSearch]="false"
            (textChange)="onSearch($event)"
            (clear)="onClear()"
          ></daui-search-input>
        </div>
      }
      <daui-scroll-viewer [hasLayoutOptimizationTrigger]="false">
        <div #content class="content" (dauiResize)="onResize($event)">
          <ng-content></ng-content>
        </div>
      </daui-scroll-viewer>
    </clr-dropdown-menu>
  }
</clr-dropdown>
